import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosGet, axiosPost } from "utils/APIHelper";
import { responseTypes } from "utils/Types";

interface ActionState {
  list: any[];
  actionDetails: any;
  status?: "idle" | "loading" | "failed";
  isCardVisited: boolean;
  totalRecords: number;
  actionShowLoader: boolean;
}

const initialState: ActionState = {
  list: [],
  isCardVisited: false,
  status: "idle",
  actionDetails: {},
  actionShowLoader: false,
  totalRecords: 0
};

export const fetchIndividualActionAsync = createAsyncThunk("individualActions", async (data: any, thunkApi) => {
  const API_URL = `cards`;
  const response: any = await axiosPost(API_URL, "", {
    ...data
  });
  if (response?.status !== responseTypes.success) {
    return thunkApi.rejectWithValue(response?.data);
  }
  return response.data;
});

export const fetchIndividualActionDetailAsync = createAsyncThunk(
  "individualActionsDetails",
  async (data: any, thunkApi) => {
    const { id, innCode, otherInnCodes } = data;
    const API_URL = `cards/${id}?innCode=${innCode}&otherInnCodes=${otherInnCodes}`;
    const response: any = await axiosGet(API_URL, "");
    if (response?.status !== responseTypes.success) {
      return thunkApi.rejectWithValue(response.data);
    }
    return response.data;
  }
);

export const ActionSlice = createSlice({
  name: "actions",
  initialState,
  reducers: {
    setIsCardVisited: (state, action) => {
      state.isCardVisited = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndividualActionAsync.pending, (state, action: any) => {
        state.status = "loading";
        state.actionShowLoader = action.meta.arg.pagination.page === 1;
      })
      .addCase(fetchIndividualActionAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.actionShowLoader = false;
        state.list =
          action.meta.arg.pagination.page === 1 ? action.payload.cards : [...state.list, ...action.payload.cards];
        state.totalRecords = action.payload.meta.page.total;
      })
      .addCase(fetchIndividualActionDetailAsync.pending, (state, action: any) => {
        state.status = "loading";
      })
      .addCase(fetchIndividualActionDetailAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.actionDetails = action.payload;
        state.isCardVisited = false;
      });
  }
});

export const { setIsCardVisited } = ActionSlice.actions;
export default ActionSlice.reducer;
